import { useTranslation } from 'react-i18next';
import { useDashboardStore } from '../../stores/Layout/dashboard';
import { useTokenContext } from '../../context/tokenContext';

const Counts = () => {
  const { t } = useTranslation();
  const { dataCount } = useDashboardStore();
  const { firstname } = useTokenContext();
  
  return (
    <div className="w-full h-auto flex justify-start items-start ">
      <div className="w-full rounded-xl h-auto flex justify-between items-center bg-white shadow-xl text-nxm-dark-gray mb-3">
            <div className="flex flex-col justify-start items-start pl-5 py-2 3xl:py-4 font-K2D ">
              <p className="text-xl font-bold text-gray-700 font-K2D">
                {t("dashboard.hello", { firstname })}
              </p>
              <p className="font-thin">{t("dashboard.title")}</p>
            </div>
            <div className="hidden lg:flex font-K2D">
              <div className="flex justify-end items-end border-r-2 my-4 xl:mx-4 mr-2">
                <p className="mr-4">{t("dashboard.openMissions")}</p>
                <p className="font-bold mr-4">
                  {dataCount?.totalOpenMissionsCount}
                </p>
              </div>
              <div className="flex justify-end items-end border-r-2 my-4 xl:mx-4 mr-2">
                <p className="mr-4">{t("dashboard.pendingRequests")}</p>
                <p className="font-bold mr-4">
                  {dataCount?.totalDocRequestsWaitingCount}
                </p>
              </div>
              <div className="flex justify-end items-end my-4 xl:mx-4 mr-2">
                <p className="mr-4">{t("dashboard.deliveredRequests")}</p>
                <p className="font-bold mr-4">
                  {dataCount?.totalDocRequestsAcceptedCount}
                </p>
              </div>
            </div>
          </div> 
    </div>
  )
}

export default Counts